import angular from 'angular';
import joint from 'jointjs';

export const jointMenu = [
  {
    category: 'parameters/quick_replies/details/graph/messages-column',
    boxes: [
      {
        type: 'html.QuestionBox',
        label: 'parameters/quick_replies/details/graph/question_box_title_in_panel',
        excludedSiteTypes: ['whatsapp'],
        inPort: true
      },
      {
        type: 'html.ListPickerBox',
        label: 'parameters/quick_replies/details/graph/list_picker_box_title_in_panel',
        inPort: true,
        siteTypes: ['business-chat'],
      },
      {
        type: 'html.WhatsappListMessageBox',
        label: 'parameters/quick_replies/details/graph/whatsapp_list_picker_box_title_in_panel',
        inPort: true,
        siteTypes: ['whatsapp'],
      },
      {
        type: 'html.MessageWithChoiceBox',
        label: 'parameters/quick_replies/details/graph/message_with_choice_box_title_in_panel',
        siteTypes: ['whatsapp', 'business-chat'],
        inPort: true
      },
      {
        type: 'html.WhatsappMessageWithButtonsBox',
        label: 'parameters/quick_replies/details/graph/whatsapp_message_with_buttons/box_title_in_panel',
        siteTypes: ['whatsapp'],
        inPort: true
      },
      {
        type: 'html.WhatsappTemplateBox',
        label: 'parameters/quick_replies/details/graph/wa_template_box_title_in_panel',
        siteTypes: ['whatsapp'],
        inPort: true
      },
      {
        type: 'html.InstagramCarrouselBox',
        label: 'parameters/quick_replies/details/graph/instagram_carrousel/box_title_in_panel',
        siteTypes: ['instagram2'],
        inPort: true
      },
      {
        type: 'html.GbmCarrouselBox',
        label: 'parameters/quick_replies/details/graph/gbm_carrousel/box_title_in_panel',
        siteTypes: ['gbm'],
        inPort: true
      },
      {
        type: 'html.LineCarrouselBox',
        label: 'parameters/quick_replies/details/graph/line_carrousel/box_title_in_panel',
        siteTypes: ['line'],
        inPort: true
      },
      {
        type: 'html.InMessageCarouselBox',
        label: 'parameters/quick_replies/details/graph/inmessage_carrousel/box_title_in_panel',
        siteTypes: ['webchat'],
        inPort: true
      },
      {
        type: 'html.ImageCarrouselBox',
        label: 'parameters/quick_replies/details/graph/line_image_carrousel/box_title_in_panel',
        siteTypes: ['line'],
        inPort: true
      },
      {
        type: 'html.ImageMapBox',
        label: 'parameters/quick_replies/details/graph/line_image_map/box_title_in_panel',
        siteTypes: ['line'],
        inPort: true
      },
      {
        type: 'html.SurveyFeedbackBox',
        label: 'parameters/quick_replies/details/graph/nps_box_title_in_panel',
        onlyInSurveyScenario: true,
        inPort: true,
      },
      {
        type: 'html.MessageWithoutQRBox',
        label: 'parameters/quick_replies/details/graph/message_without_qr_box_title_in_panel',
        inPort: true
      },
      {
        type: 'html.WaitForMessageBox',
        label: 'parameters/quick_replies/details/graph/wait_for_message_box_title_in_panel',
        inPort: true
      },
      {
        type: 'html.MessengerGenericTemplateAManoBox',
        label: 'parameters/quick_replies/details/graph/messenger_generic_template_box_mano_title_in_panel',
        siteTypes: ['facebook'],
        inPort: true
      },
      {
        type: 'html.MessengerMediaTemplateAManoBox',
        label: 'parameters/quick_replies/details/graph/messenger_media_template_box_title_in_panel',
        siteTypes: ['facebook'],
        inPort: true
      },
      {
        type: 'html.MessengerButtonTemplateAManoBox',
        label: 'parameters/quick_replies/details/graph/messenger_button_template_box_title_in_panel',
        siteTypes: ['facebook'],
        inPort: true
      },
      {
        type: 'html.BZCRichLinkAManoBox',
        label: 'parameters/quick_replies/details/graph/rich_link_a_mano_box_title_in_panel',
        siteTypes: ['business-chat'],
        inPort: true
      },
      {
        type: 'html.EmailRequestForNotificationBox',
        label: 'parameters/quick_replies/details/graph/email_request_for_notification_box_in_panel',
        siteTypes: ['webchat'],
        inPort: true
      },
      {
        type: 'html.PhoneRequestForNotificationBox',
        label: 'parameters/quick_replies/details/graph/phone_request_for_notification_box_in_panel',
        siteTypes: ['webchat'],
        inPort: true
      },
      {
        type: 'html.ConfirmBox',
        label: 'parameters/quick_replies/details/graph/line_confirm_box/box_title_in_panel',
        siteTypes: ['line'],
        inPort: true
      },
    ]
  },
  {
    category: 'parameters/quick_replies/details/graph/tools-column',
    boxes: [
      {
        type: 'html.ActionBox',
        label: 'parameters/quick_replies/details/graph/action_box_title_in_panel',
        inPort: true
      },
      {
        type: 'html.IfThenElseBox',
        label: 'parameters/quick_replies/details/graph/if_then_else_box_title_in_panel',
        inPort: true
      },
      {
        type: 'html.ConditionsVariablesMultipleBox',
        label: 'parameters/quick_replies/details/graph/conditions-variable-multiple-in-panel',
        inPort: true
      },
      {
        type: 'html.BHNBHBox',
        label: 'parameters/quick_replies/details/graph/bh_nbh_box_title_in_panel',
        inPort: true
      },
      {
        type: 'html.OptinNotOptinBox',
        label: 'parameters/quick_replies/details/graph/optin_not_optin_box_title_in_panel',
        inPort: true
      },
      {
        type: 'html.ConditionsOnUserInputBox',
        label: 'parameters/quick_replies/details/graph/condition_on_user_input',
        inPort: true
      },
      {
        type: 'html.ConditionsOnCustomFieldsBox',
        label: 'parameters/quick_replies/details/graph/conditions_on_custom_fields',
        inPort: true
      },
      {
        type: 'html.UserLanguagesBox',
        label: 'parameters/quick_replies/details/graph/user_languages_box',
        siteTypes: ['business-chat'],
        inPort: true
      },
      {
        type: 'html.UserCountriesBox',
        label: 'parameters/quick_replies/details/graph/user_countries_box',
        siteTypes: ['business-chat'],
        inPort: true
      },
      {
        type: 'html.ForkWithDelayBox',
        label: 'parameters/quick_replies/details/graph/fork_with_delay_box_title_in_panel',
        inPort: true
      },
      {
        type: 'html.TriggerSurveyBox',
        label: 'parameters/quick_replies/details/graph/trigger_survey_box_title_in_panel',
        inPort: true,
        notInSurveyScenario: true,
        onlyInCampaignScenario: true
      },
      {
        type: 'html.SetCustomFieldBox',
        label: 'parameters/quick_replies/details/graph/set_custom_field_title_in_panel',
        inPort: true,
      },
      {
        type: 'html.PromoCodeBox',
        label: 'parameters/quick_replies/details/graph/promo_code_box_title_in_panel',
        inPort: true,
      },
      {
        type: 'html.NoteBox',
        label: 'parameters/quick_replies/details/graph/note/title-in-panel',
        inPort: false,
        limit: 30
      },
    ]
  },
  {
    category: 'parameters/quick_replies/details/graph/entry-points-column',
    boxes: [
      {
        type: 'html.FirstConversationEverBox',
        label: 'parameters/quick_replies/details/graph/first_conversation_ever_box_title_in_panel',
      },
      {
        type: 'html.FollowingConversationsBox',
        label: 'parameters/quick_replies/details/graph/following_conversations_box_title_in_panel',
        excludedSiteTypes: ['line'],
      },
      {
        type: 'html.UnexpectedUserInputBox',
        label: 'parameters/quick_replies/details/graph/unexpected_user_input_box_title_in_panel',
        excludedSiteTypes: ['line'],
      },
      {
        type: 'html.AgentShortcutBox',
        label: 'parameters/quick_replies/details/graph/agent_shortcut_box_title_in_panel',
      },
      {
        type: 'html.MassMessagingEntryPointBox',
        label: 'parameters/quick_replies/details/graph/mass_messaging_box_title_in_panel',
        excludedSiteTypes: ['line', 'kakaotalk'],
      },
      {
        type: 'html.MessengerMDotMeLinkBox',
        label: 'parameters/quick_replies/details/graph/m_dot_me_box_title_in_panel',
        siteTypes: ['facebook']
      },
      {
        type: 'html.ClickToMessengerBox',
        label: 'parameters/quick_replies/details/graph/click_to_messenger_box_title_in_panel',
        siteTypes: ['facebook'],
        notInSurveyScenario: true
      },
      {
        type: 'html.SponsoredBzcMessageBox',
        label: 'parameters/quick_replies/details/graph/sponsored_bzc_message_box_title_in_panel',
        siteTypes: ['business-chat']
      },
      {
        type: 'html.LineRichMenuBox',
        label: 'parameters/quick_replies/details/graph/line_rich_menu_box_title_in_panel',
        siteTypes: ['line']
      },
      {
        type: 'html.WhatsappCartSentBox',
        label: 'parameters/quick_replies/details/graph/whatsapp_cart_sent_box_title_in_panel',
        siteTypes: ['whatsapp'],
      },

      {
        type: 'html.WhatsappWelcomeMessageBox',
        label: 'parameters/quick_replies/details/graph/whatsapp_welcome_message_box_title_in_panel',
        siteTypes: ['whatsapp-cloud-api'],
      },
      {
        type: 'html.OptinCTSBox',
        label: 'parameters/quick_replies/details/graph/optin_cts_box_title_in_panel',
        siteTypes: ['facebook'],
        notInSurveyScenario: true,
        onlyInCampaignScenario: true,
      },
    ]
  },
  {
    category: 'parameters/quick_replies/details/graph/expert-column',
    boxes: [
      {
        type: 'html.HandoverBox',
        label: 'parameters/quick_replies/details/graph/handover_box_title_in_panel',
        excludedSiteTypes: ['kakaotalk'],
        inPort: true
      },
      {
        type: 'html.ReceiveControlBox',
        label: 'parameters/quick_replies/details/graph/receive_control_box_title_in_panel',
        onlyInSecondaryScenario: true
      },
      {
        type: 'html.ExternalEndpointEntryPointBox',
        label: 'parameters/quick_replies/details/graph/external_endpoint_box_title_in_panel',
        excludedSiteTypes: ['kakaotalk'],
      },
      {
        type: 'html.LinkWithRefEntryPointBox',
        label: 'parameters/quick_replies/details/graph/link_with_ref_entry_point_title_in_panel',
        siteTypes: ['webchat'],
      },
      {
        type: 'html.SubBotBox',
        label: 'parameters/quick_replies/details/graph/subbot_box_title_in_panel',
        excludedSiteTypes: ['kakaotalk'],
        inPort: true,
      },
      {
        type: 'html.BotConnectorBox',
        label: 'parameters/quick_replies/details/graph/bot_connector_box_title_in_panel',
        inPort: true,
      },
      {
        type: 'html.FacebookProductBox',
        label: 'parameters/quick_replies/details/graph/facebook_product_box_title_in_panel',
        siteTypes: ['facebook'],
        inPort: true,
      },
      {
        type: 'html.RecurringNotifBox',
        label: 'parameters/quick_replies/details/graph/recurring_notif_box_title_in_panel',
        siteTypes: ['facebook', 'instagram2'],
        inPort: true,
      },
      {
        type: 'html.AiConnectorBox',
        label: 'parameters/quick_replies/details/graph/ai_connector/box_title_in_panel',
        siteTypes: ['whatsapp', 'facebook', 'webchat', 'line'],
        inPort: true,
      },
      {
        type: 'html.ApiConnectorBox',
        label: 'parameters/quick_replies/details/graph/api_connector/box_title_in_panel',
        inPort: true,
      },
      {
        type: 'html.AiSatisfactionBox',
        label: 'parameters/quick_replies/details/graph/ai-satisfaction/title-in-panel',
        siteTypes: ['whatsapp', 'facebook', 'webchat', 'line'],
        inPort: true
      },
      {
        type: 'html.TextMatchBox',
        label: 'parameters/quick_replies/details/graph/text-match/title-in-panel',
        inPort: true
      },
    ]
  },
]

export function initMenus(context) {
  const drawerMenu = angular.copy(jointMenu);
  const siteType = context.site.type_name;
  const { isCloudAPI } = context.site;
  drawerMenu.forEach(section => {
    section.boxes = section.boxes.filter(box => !box.siteTypes || box.siteTypes.includes(siteType) || (box.siteTypes.includes('whatsapp-cloud-api') && isCloudAPI)); // Filter out the boxes that do not belong to this site type
    section.boxes = section.boxes.filter(box => !box.excludedSiteTypes || !box.excludedSiteTypes.includes(siteType)); // Filter out the boxes which exclude this site type
    if (context.isSatisfactionSurvey) {
      section.boxes = section.boxes.filter(box => !box.notInSurveyScenario); // Filter out the boxes that do not appear in surveys
    }
    if (!context.isSatisfactionSurvey) {
      section.boxes = section.boxes.filter(box => !box.onlyInSurveyScenario); // Filter out the boxes that only appear in surveys
    }
    if (!context.isSecondary) {
      section.boxes = section.boxes.filter(box => !box.onlyInSecondaryScenario);  // Filter out the boxes that appear in secondary scenarios only
    }
    if (!context.isCampaignScenario) {
      section.boxes = section.boxes.filter(box => !box.onlyInCampaignScenario);  // Filter out the boxes that appear in campaign scenarios only
    }
    section.boxes.forEach(box => {
      if (box.labelsBySiteType && box.labelsBySiteType[siteType]) {
        box.label = box.labelsBySiteType[siteType]; // overwrite label if it needs to change for the current site type
      }
      if (box.limit && box.type === 'html.NoteBox') {
        box.disabled = () => (context.noteBoxesSet?.size || 0) >= context.noteLimitation;
      }
    });
  });
  const boxesWithInPort = angular.copy(drawerMenu);
  boxesWithInPort.forEach(e => e.boxes = e.boxes.filter(box => box.inPort)); // Filter the boxes that have an in port

  return { drawerMenu, boxesWithInPort };
}

export function setBorderColors(menu) {
  menu.forEach(e => {
    e.boxes.forEach(box => {
      box.borderColor = joint.shapes.html[box.type.split('.')[1]].prototype.defaults.labelFill
    }); // Set the border color property for each box
  });
}
